import React from "react";
import { t } from "ttag";

import {
    FootNote,
    SizeCell,
    SizeImg,
    SplitCaKingCell,
    SplitKingCell,
    TooltipContent,
    TooltipTrigger,
    sizeIcons,
} from "./_shared";

const SPLIT_HEAD_KING_TIP =
    "One mattress with a split to allow for independent head movements with a Split King adjustable base.";

/**
 * Native port of ``cms/blocks/product-specifications/luxebreezesplit.html``
 * (#33410). Distinct from LuxeBreeze by the EXTRA fourth "Split Head King" cell
 * -- a linked heading (``<a href="/shop-mattresses/split-head-king">``) with its
 * own tooltip copy and the ``adapt_split_head_king`` icon. This is why the block
 * must dispatch on ``template_name`` (not ``slug``): ``luxebreezesplit`` and
 * ``luxebreeze`` both slugify to ``luxebreeze`` (the row ``title`` property
 * deliberately collapses ``LuxeBreezeSplit`` -> ``"LuxeBreeze®"``), so a
 * slug-keyed registry would silently drop this cell.
 */
export const LuxeBreezeSplit = (): React.JSX.Element => (
    <div className="breeze-specifications">
        <SizeCell
            icon={sizeIcons.adaptTwinXl}
            heading="Twin Long"
            lines={['38" x 80"', "Single Mattress", "78-100 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptQueen}
            heading="Queen"
            lines={['60" x 80"', "Single Mattress", "123-168 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptKing}
            heading="King"
            lines={['76" x 80"', "Single Mattress", "157-216 lbs"]}
        />
        <div>
            <SizeImg icon={sizeIcons.adaptSplitHeadKing} />
            <h5 className="product-specifications-block__size-heading">
                <a href="/shop-mattresses/split-head-king">Split Head King</a>
                <TooltipTrigger
                    text={SPLIT_HEAD_KING_TIP}
                    srText={t`Split Head King size details`}
                />
            </h5>
            <TooltipContent text={SPLIT_HEAD_KING_TIP} />
            <p>76&quot; x 80&quot;</p>
            <p>Single Mattress</p>
            <p>141-197 lbs</p>
        </div>
        <SplitKingCell
            lines={['76" x 80"', "Double Mattress", "156-210 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptCaKing}
            heading="CA King"
            lines={['72" x 84"', "Single Mattress", "157-216 lbs"]}
        />
        <SplitCaKingCell
            lines={['72" x 84"', "Double Mattress", "156-210 lbs"]}
        />

        <FootNote />
    </div>
);
